import React from "react";
import { docLazyFn } from '@/router/untilFn'

// 沙盒-导航栏
import SandBox from '@/components/SandBox'

// PropertyManagement
import PropertyManagement from '@/views/PropertyManagement/Property'
import MapAll from '@/views/PropertyManagement/Property/component/MapAll'
import Map from '@/components/Map'
import EntityIndex from '@/views/PropertyManagement/Entity'
import OwnerIndex from '@/views/PropertyManagement/Owner'
import GroupIndex from '@/views//PropertyManagement/Group'
import CompanyIndex from '@/views//PropertyManagement/Company'
import CreditCheckIndex from '@/views/PropertyManagement/CreditCheck'
import ThreeDayNotice from '@/views/PropertyManagement/ThreeDayNotice'
const propertyManagement = [
  {
    path: "/PropertyManagement",
    element: <SandBox />,
    children: [
      {
        path: "Property",
        element: docLazyFn(<PropertyManagement />),
      },
      {
        path: "creditCheck",
        element: docLazyFn(<CreditCheckIndex />),
      },
      {
        path: "ThreeDayNotice",
        element: docLazyFn(<ThreeDayNotice />),
      },
     {
        path: "Entity",
        element: docLazyFn(<EntityIndex />),
      },{
          path: "Owner",
        element: docLazyFn(<OwnerIndex />),
      },{
          path: "Group",
        element: docLazyFn(<GroupIndex />),
      },{
               path: "Company",
        element: docLazyFn(<CompanyIndex />), 
      }
    ],
  },
  // 不带沙盒
  {
    path: "/PropertyManagement/Property/MapAll",
    element: docLazyFn(<MapAll />),
  },
  {
    path: "/PropertyManagement/Property/Map",
    element: docLazyFn(<Map />),
  },
];

export default propertyManagement;
